/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { object } from 'prop-types';
import styles from './social-media-links.module.scss';

const FRAME_HEIGHT = '436';
const FRAME_WIDTH = '626';

const Twitter = ({ props = {} }) => {
  const {shareable, href} = props

  if (!href) {
    return null;
  }
  const onTwitterClick = () => {
    window.open(href, 'share_to_twitter', `width=${FRAME_WIDTH},height=${FRAME_HEIGHT}`)
  }

  return (
    <a
      data-testid="twitter-element"
      className=""
      href={href}
      title="Twitter"
      target="_blank"
      rel="nofollow"
      onClick = {shareable && onTwitterClick}
    >
      <svg width="25px" height="25px" viewBox="0 0 25 25" version="1.1" style={{ paddingRight: '5px'  }}>
        <g id="MW---Katie" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="blog/author-bio/v3" transform="translate(-127.000000, -542.000000)" fill="#666666" fillRule="nonzero">
            <g id="Organism-/-ALP-/-Card-/-Project-Guide-Initial-Copy-7" transform="translate(10.000000, 282.000000)">
              <g id="social" transform="translate(17.000000, 260.000000)">
                <g id="Shape-2" transform="translate(100.000000, 0.000000)">
                  <path d="M25,12.5 C25,19.40625 19.40625,25 12.5,25 C5.59375,25 0,19.40625 0,12.5 C0,5.59375 5.59375,0 12.5,0 C19.40625,0 25,5.59375 25,12.5 Z M10.2125,19.09375 C15.75625,19.09375 18.7875,14.5 18.7875,10.51875 C18.7875,10.3875 18.7875,10.25625 18.78125,10.13125 C19.36875,9.70625 19.88125,9.175 20.2875,8.56875 C19.75,8.80625 19.16875,8.96875 18.55625,9.04375 C19.18125,8.66875 19.65625,8.08125 19.88125,7.375 C19.3,7.71875 18.65625,7.96875 17.96875,8.10625 C17.41875,7.51875 16.6375,7.15625 15.76875,7.15625 C14.10625,7.15625 12.75625,8.50625 12.75625,10.16875 C12.75625,10.40625 12.78125,10.6375 12.8375,10.85625 C10.33125,10.73125 8.1125,9.53125 6.625,7.70625 C6.36875,8.15 6.21875,8.66875 6.21875,9.21875 C6.21875,10.2625 6.75,11.1875 7.5625,11.725 C7.06875,11.7125 6.60625,11.575 6.2,11.35 C6.2,11.3625 6.2,11.375 6.2,11.3875 C6.2,12.85 7.2375,14.0625 8.61875,14.34375 C8.36875,14.4125 8.1,14.45 7.825,14.45 C7.63125,14.45 7.44375,14.43125 7.25625,14.39375 C7.6375,15.59375 8.75,16.4625 10.06875,16.4875 C9.0375,17.29375 7.7375,17.775 6.325,17.775 C6.08125,17.775 5.84375,17.7625 5.60625,17.73125 C6.925,18.59375 8.5125,19.09375 10.2125,19.09375" id="Shape" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </a>
  );
};

Twitter.propTypes = {
  props: object.isRequired
};

Twitter.displayName = 'Twitter';

export { Twitter };
